import http from 'plugins/axios';

export default {
  exportExcel(data) {
    return http.get({
      url: `/ta/admin/tenant/workorder/findByUse/wallet/excel`,
      data,
      responseType: 'blob',
    })
  },
  getExcelData(data) {
    return http.get({
      url: `/ta/admin/tenant/workorder/getSearchExport`,
      data,
      responseType: 'blob',
    })
  },
  getChains() {
    return http.get({
      url: '/ta/admin/tenant/coin/chain/list'
    })
  },

  getAuditList(data) {
    return http.get({
      url: '/ta/admin/tenant/workorder/search_withdraw',
      data
    });
  },
  approveAudit(data) {
    return http.post({
      url: '/ta/admin/tenant/workorder/approve_withdraw',
      data,
      dataType: 'form'
    });
  },
  //批量审核
  batchApproveAudit(data) {
    return http.post({
      url: `/ta/admin/tenant/workorder/approve_withdraw/list`,
      data
    })
  },
  retryWithdrawal(data) {
    return http.post({
      url: '/ta/admin/tenant/workorder/retry_withdraw',
      data,
      dataType: 'form'
    });
  },
  setToErrList(id) {
    return http.post({
      url: '',
      data: { id },
      dataType: 'form'
    });
  },
  cancelAudit(id) {
    return http.post({
      url: '',
      data: { id },
      dataType: 'form'
    });
  },
  getAllCoins() {
    return http.get({
      url: '/ta/admin/tenant/coin/allDisplay'
    });
  },
  getUserRecords(data) {
    return http.get({
      url: '/ta/admin/tenant/workorder/findByUse/Forward',
      data: {
        useId: data.userId,
        page: data.page,
        size: data.size
      }
    });
  },
  getBillTypeList() {
    return http.get({
      url: '/ta/admin/tenant/bill/types'
    });
  },
  updateFreeze(data) {
    return http.post({
      url: '/ta/admin/tenant/workorder/freeze_withdraw',
      data,
      dataType: 'form'
    });
  },
  cancel(data) {
    return http.post({
      url: '/ta/admin/tenant/workorder/cancel_withdraw',
      data,
      dataType: 'form'
    });
  },
  sendTheWithdrawalTrans(data) {
    return http.post({
      url: '/ta/admin/tenant/workorder/handed_network_withdraw',
      data: {
        networkId: data.transId,
        id: data.id,
        googleCode: data.googleCode
      },
      dataType: 'form'
    });
  },
  getUserWallet(id) {
    return http.get({
      url: '/ta/admin/tenant/workorder/findByUse/wallet',
      data: {
        userId: id
      }
    });
  },
  remark(data) {
    return http.get({
      url: '/ta/admin/tenant/workorder/add/remark',
      data
    });
  },
  manualConfirm(id) {
    return http.post({
      url: '/ta/admin/tenant/workorder/manual_confirm',
      data: {
        id
      },
      dataType: 'form'
    });
  },
  returnToNotApproved(id) {
    return http.post({
      url: '/ta/admin/tenant/workorder/return_to_not_approved',
      data: {
        id
      },
      dataType: 'form'
    });
  },
  sentConfirmed(data) {
    return http.post({
      url: '/ta/admin/tenant/workorder/withdraw/sent',
      data,
      dataType: 'form'
    });
  },
  getWithdrawGoogleAuthSession() {
    return http.get({
      url: '/ta/admin/tenant/workorder/withdraw/google_auth_session'
    });
  },
  verifyWithdrawGoogleAuth(data) {
    return http.post({
      url: '/ta/admin/tenant/workorder/withdraw/verify_google_auth',
      data,
      dataType: 'form'
    });
  },
  getWithdrawApprovalTimeline(data) {
    return http.get({
      url: '/ta/admin/tenant/workorder/withdraw_approval_timeline',
      data
    });
  },
  submitWithdrawReview(data) {
    return http.post({
      url: '/ta/admin/tenant/workorder/submit_withdraw_review',
      data,
      dataType: 'form'
    });
  },
  submitWithdrawReviewList(data) {
    return http.post({
      url: '/ta/admin/tenant/workorder/submit_withdraw_review/list',
      data,
      dataType: 'form'
    });
  },
  getWithdrawReviewTxBounds(data) {
    return http.get({
      url: '/ta/admin/tenant/workorder/withdraw/review_user_tx_bounds',
      data
    });
  },
  getWithdrawReviewTxSummary(data) {
    return http.get({
      url: '/ta/admin/tenant/workorder/withdraw/review_user_tx_summary',
      data
    });
  },
  getWithdrawReviewTxPage(data) {
    return http.get({
      url: '/ta/admin/tenant/workorder/withdraw/review_user_tx_page',
      data
    });
  }
};
